

import Img_1 from './IMG_1.jpg';
import Img_2 from './IMG_2.jpg';
import Img_3 from './IMG_3.jpg';
import Img_4 from './IMG_4.jpg';

import Img_5 from './IMG_5.jpg';
import Img_6 from './IMG_6.jpg';
import Img_7 from './IMG_7.jpg';
import Img_8 from './IMG_8.jpg';
import Img_9 from './IMG_9.jpg'

export const Portfolio = () => {

    return (
        <section id="Portfolio">
            <h2>Portfolio</h2>
            <div id="wd-img-bl">
                <img src={Img_1} alt="Img_1" />
                <img src={Img_2} alt="Img_1" />
                <img src={Img_3} alt="Img_1" />
                <img src={Img_4} alt="Img_1" />
                <img src={Img_5} alt="Img_1" />
                <img src={Img_6} alt="Img_1" />
                <img src={Img_7} alt="Img_1" />
                <img src={Img_8} alt="Img_1" />
                <img src={Img_9} alt="Img_1" />
            </div>
        </section>
    );
}